export default __webpack_public_path__ + "static/list1grid-img3-67b4dffca2ae8358b36f797ca87bcfdc.jpg";